import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ThemingService } from 'src/app/theming.service';
import { ApiService } from 'src/app/api.service';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';
declare var $: any;

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  @ViewChild('editor') editorElement!: ElementRef;
  modules = {};
  editor: any;
  privacyPolicyContent: string = '';

  loading = false;
  isEditingPrivacy: boolean = false;

  constructor(
    private appComponent: AppComponent,
    private themingService: ThemingService,
    private apiService: ApiService,
    private lambdaService: LambdaService,
  ) {}

  ngOnInit(): void {
    this.appComponent.goToTop();
    const url = this.themingService.privacyPolicies;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    const self = this;
    xhr.onreadystatechange = function process() {
      if (xhr.readyState == 4 && xhr.status === 200) {
        self.privacyPolicyContent = xhr.responseText;
      }
    };
    xhr.send();
  }

  switchEditingPrivacy(){
    this.isEditingPrivacy = !this.isEditingPrivacy;
  }

  savePrivacyPolicy() {
    this.loading = true;
    let stage = environment.stage == "test"? "dev": environment.stage;
    this.lambdaService.uploadHtmlContent(`${this.themingService.shopId}/${stage}/config-files/policy-file.html`, this.privacyPolicyContent, {})
    .then((response: any) => {
      $('#successPolicyModal').modal('show');
    })
    .catch((error: any) => {
      console.error('Error saving changes:', error);
      $('#errorPolicyModal').modal('show');
    });
    this.switchEditingPrivacy();
  }

  closeModal(){
    $('#successPolicyModal').modal('hide');
    $('#errorPolicyModal').modal('hide');
  }
}
